import { useSelector } from 'react-redux';

import { OrgStatus } from '@constants/generic';

const useKycPendingStatus = () => {
  const { orgConfig } = useSelector((state: any) => state.user);
  const isKycPending = orgConfig?.kyc_status === OrgStatus.PENDING;

  return { isKycPending };
};

export default useKycPendingStatus;
